/* =================== CAMPANHAS RECENTES =================== */
$(function () {
  $(".carrossel-recentes").each(function () {
    const $carousel = $(this);
    const totalItens = $carousel.find(".splide__slide").length;

    const cols = {
      desktop: 3,
      tablet: 2,
      mobile: 1,
    };

    let carouselOpts = {
      type: "slide",
      perPage: cols.desktop,
      gap: "30px",
      arrows: true,
      pagination: true,
      breakpoints: {
        1024: {
          perPage: cols.tablet,
          gap: "20px",
        },
        768: {
          perPage: cols.mobile,
          gap: "15px",
          padding: { right: "35px" }, // Deixa um pedaço do próximo card à mostra no mobile (UX premium)
        },
      },
    };

    // Centraliza se houver menos itens do que colunas
    if (totalItens < cols.desktop) {
      $carousel.addClass("carousel-force-center");
      carouselOpts.type = "slide";
      carouselOpts.arrows = false;
      carouselOpts.pagination = false;
      carouselOpts.drag = false;
    }

    let carousel = new Splide($carousel[0], carouselOpts);
    carousel.mount();
  });
});
